import React from 'react';
import LogoSVG from './LogoSVG';

class Loader extends React.Component {
	constructor(props) {
		super(props);
	}
	// componentDidMount() {
	// 	document.querySelector('#mole__loader span').addEventListener('animationend', (e) => {
	// 		document.querySelector('#mole__loader').classList.remove('animating');
	// 		setTimeout(() => {
	// 			document.querySelector('#mole__loader').classList.add('animating');
	// 		}, 30);
	// 	});
	// }
	render() {
		return (
			<section id="mole__loader" className="animating bg-general c-white">
				<div className="main-container">
					<div className="inner-container">
						<div className="posiR">
							<LogoSVG/>
							<span></span>
						</div>
					</div>
				</div>
			</section>
		);
	}
}
export default Loader;


// WEBPACK FOOTER //
// ./src/components/inc/Loader.js